import {API_BASE_URL} from '../../constants';
import {ImportMapping, MassDataUploadRequestDto} from '../../models';
import {get, post} from '../api';

export function getMapping(name: string, token: string | undefined) {
  return get(`${API_BASE_URL}/massEdit/mapping/${name}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}

export function uploadData(
  mapping: ImportMapping | undefined,
  data: Record<string, unknown>[],
  token: string | undefined,
) {
  return post(`${API_BASE_URL}/massEdit/upload`, {
    data: JSON.stringify({
      mappingId: mapping?.name,
      data: data,
    } as MassDataUploadRequestDto),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}
